export default {
  CHAT: 'Chat',
  CHAT_SYSTEM_MESSAGE_SECURE_CHAT: `This secure chat can only be seen by people on this call.`,
  CHAT_SYSTEM_MESSAGE_ALONE_IN_CHAT: `New messages will be visible when someone rejoins the call.`,
  CHAT_MESSAGE_META_TAG_REMOTE: `{{name}} at {{timestamp}}`,
  CHAT_MESSAGE_META_TAG_LOCAL: `You at {{timestamp}}`,
  CHAT_TYPING_INDICATOR_MULTIPLE_USERS_META: `Multiple users are typing ...`,
  CHAT_TYPING_INDICATOR_META: `{{name}} is typing ...`,
  CHAT_MESSAGE_INPUT_PLACEHOLDER: 'Write your message here',
  CHAT_JOIN_ERROR_RETRY_HEADER: `We’re having trouble loading chat.`,
  CHAT_JOIN_ERROR_RETRY_SUB_TEXT: `Please try reloading and see if that fixes the problem.`,
  CHAT_JOIN_ERROR_TRY_RELOAD_BTN: `Try Reloading`,
  CHAT_JOIN_ERROR_BACK_TO_CALL_BTN: `Go Back To Call`,
  CHAT_JOIN_ERROR_RELOADING_BTN: `Reloading`,
  CHAT_JOIN_ERROR_DISABLED_BTN: `Reload chat`,
  CHAT_JOIN_ERROR_HEADER: `Sorry, we can’t load chat.`,
  CHAT_JOIN_ERROR_SUB_TEXT: `Please go back to the call. We apologize for this technical problem.`,
  CHAT_WELCOME: `Welcome to Chat`,
  CHAT_DISABLED_WITHOUT_PROVIDER: `You'll be able to send messages once your care team joins the call.`,
  CHAT_NEW_FEATURE: `This new feature isn't fully activate for everyone yet.`,
  CHAT_ATTENTION: `When you type in the chat, check with other people on the call if they can see your message.  Thanks for your patience while we are improving this feature!`,
  CHAT_TOAST_HEADER: `Chat from {{senderName}}`,
  CHAT_TOAST_REPLY: `Reply`,
  CHAT_MESSAGE_FAILURE_META: `Message not delivered`,
};
